const initialState = {
    isUploadingBlastList: false,
    isDownloadingFile: false,
    isUploadingFile: false
}

export default initialState;
